export const ACTIVITY_ENTRY_AUTOSAVE_STORAGE_KEY =
    "ntcog-activity-entry-autosave-enabled";
export const ACTIVITY_ENTRY_PREFERENCES_UPDATED_EVENT =
    "ntcog-activity-entry-preferences-updated";
export const ACTIVITY_ENTRY_AUTOSAVE_INTERVAL_MS = 60_000;
export const ACTIVITY_ENTRY_SAVE_REMINDER_MS = 5 * 60_000;

export function getActivityEntryAutoSaveEnabled(): boolean {
    if (typeof window === "undefined") return true;

    const savedPreference = window.localStorage.getItem(
        ACTIVITY_ENTRY_AUTOSAVE_STORAGE_KEY
    );

    if (savedPreference === null) {
        return true;
    }

    return savedPreference === "true";
}

export function setActivityEntryAutoSaveEnabled(enabled: boolean): void {
    if (typeof window === "undefined") return;

    window.localStorage.setItem(
        ACTIVITY_ENTRY_AUTOSAVE_STORAGE_KEY,
        String(enabled)
    );
    window.dispatchEvent(new Event(ACTIVITY_ENTRY_PREFERENCES_UPDATED_EVENT));
}
